import { updateProgress } from '../../../../app-main/actions/flow';
import { createGuestUpdate } from '../../../../app-main/actions/contracts';

const submitGuestUpdateForm = (values = {}, dispatch, props) => {
  const {
    getFeeCalc,
    submitGuestUpdate,
    showAddOns,
    currentStep,
    controlId,
    accessToken,
    submitCallback,
    contractQuoteError
  } = props;
  const withAddOnsQuote = showAddOns && 3 > currentStep;

  // don't move to the next step if there is an error
  if (contractQuoteError) { return; }

  if (withAddOnsQuote || (!showAddOns && 2 > currentStep)) {
    getFeeCalc((status) => {
      if (400 === status) {
        return;
      }

      if (withAddOnsQuote) {
        return dispatch(updateProgress(currentStep + 1));
      }

      if (2 > currentStep) {
        return dispatch(updateProgress(currentStep + 1));
      }
    });

    return;
  }

  submitGuestUpdate(values, (error, payload) => {
    dispatch(createGuestUpdate(payload, controlId, accessToken, (response) => {
      submitCallback(response);
    }));
  });
};

export default submitGuestUpdateForm;
